import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, Text } from 'react-native'
import { useResponsive } from '../../../../../../components/src/hooks'
import BuilderBottomModal from '../../../../ui/molecules/BuilderBottomModal'

export const WhatIsPenaltyModal: React.FC<{
  visible: boolean
  setVisible: (arg: boolean) => void
}> = ({ visible, setVisible }) => {
  const { t } = useTranslation('global')
  const { sm } = useResponsive()
  return (
    <BuilderBottomModal
      visible={visible}
      height={sm ? '25%' : '40%'}
      width={sm ? 400 : undefined}
      onClose={() => setVisible(false)}
      title={
        <Text style={styles.title}>
          {t('CreditTab.why-penalty-is-charged-title')}
        </Text>
      }
    >
      <Text style={styles.subtitle}>
        {t('CreditTab.why-penalty-is-charged-message')}
      </Text>
    </BuilderBottomModal>
  )
}

const styles = StyleSheet.create({
  title: {
    fontWeight: '700',
    fontSize: 20,
    lineHeight: 28,
    color: '#003353',
    marginLeft: -30,
    flex: 1,
  },
  subtitle: {
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 22,
    color: '#003353',
  },
})
